import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Box, Container } from "@mui/material";

type LayoutProps = {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  showHeader?: boolean;
  showFooter?: boolean;
  mainPadding?: number | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
};

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  maxWidth = 'xl',
  showHeader = true,
  showFooter = true,
  mainPadding = 4
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // Ensure the container takes up at least the full viewport height
      }}
    >
      {showHeader && <Header />}
      <Box
        component="main"
        sx={{
          flexGrow: 1, // Allow the main content to take up available space
          display: 'flex',
          flexDirection: 'column',
          py: mainPadding
        }}
      >
        <Container maxWidth={maxWidth} sx={{ flex: 1 }}>{children}</Container>
      </Box>
      {showFooter && <Footer />}
    </Box>
  );
};

export default Layout;
